import classNames from "classnames";
import moment from "moment";
import React from "react";
import {
	ECRBRecordState,
	TCRBBackendRecord,
	TCRBRecord,
} from "../../../../redux/app/crb/@types";
import { marpolUtils } from "../../../../redux/app/marpol";
import CRBTableRows from "./CRBTableRows";
import getSignTableRows from "./getSignTableRows";

type OwnProps = {
	isSubmitterChiefOrMaster: boolean;
	crbRecord: TCRBBackendRecord;
};
type CRBRecordParticipantsViewProps = OwnProps;
function CRBRecordParticipantsView(props: CRBRecordParticipantsViewProps) {
	const { crbRecord } = props;

	return (
		<CRBTableRows record={crbRecord} tableRows={getSignTableRows(crbRecord)} />
	);
}

export default CRBRecordParticipantsView;
